export const CURRENCY = 'CZK'
